// // src/pages/AboutPage.jsx
// import React, { useState, useEffect } from 'react';

// const AboutPage = () => {
//   const [expandedService, setExpandedService] = useState(null);
//   const [isMobile, setIsMobile] = useState(false);

//   // Check screen size for responsive adjustments
//   useEffect(() => {
//     const checkMobile = () => {
//       setIsMobile(window.innerWidth < 768);
//     };
    
//     checkMobile();
//     window.addEventListener('resize', checkMobile);
//     return () => window.removeEventListener('resize', checkMobile);
//   }, []);

//   // Updated Business Information
//   const businessInfo = {
//     name: "Laminance",
//     founded: "2024",
//     address: "418 Rt 23, Franklin, NJ, 07416",
//     phone: "(862) 450-6069",
//     email: "Contactus@laminance.com",
//     area: "Franklin, NJ and surrounding areas"
//   };

//   // Updated transformation package with starting price
//   const transformationPackage = {
//     startingPrice: "$25,000",
//     title: "Complete Kitchen Transformation",
//     description: "Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.",
//     includes: [
//       {
//         title: "Premium Cabinets",
//         icon: "🗄️",
//         details: "Custom-built cabinets with your choice of acrylic, matte, gloss, or shaker styles"
//       },
//       {
//         title: "Luxury Countertops",
//         icon: "✨",
//         details: "Quartz, granite, or marble countertop installation with professional sealing"
//       },
//       {
//         title: "Designer Backsplash",
//         icon: "🧱",
//         details: "Professional backsplash design with premium tile selection and installation"
//       },
//       {
//         title: "Professional Painting",
//         icon: "🎨",
//         details: "Complete kitchen painting with premium, low-VOC paints and protective coatings"
//       },
//       {
//         title: "High-End Sink & Plumbing",
//         icon: "🚰",
//         details: "Undermount or farmhouse sink with professional plumbing and garbage disposal"
//       },
//       {
//         title: "Premium Hardware",
//         icon: "🔩",
//         details: "Hand-selected knobs, pulls, soft-close hinges, and all finishing hardware"
//       },
//       {
//         title: "Electrical Updates",
//         icon: "💡",
//         details: "Lighting fixtures, outlets, under-cabinet lighting, and any necessary electrical work"
//       },
//       {
//         title: "Complete Installation",
//         icon: "👷",
//         details: "Full labor from demolition to final inspection and cleanup"
//       }
//     ]
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white mt-16">
//       {/* SEO Meta Tags */}
//       <head>
//         <title>About Laminance | Premium Kitchen Cabinets & Complete Kitchen Transformation in Franklin, NJ</title>
//         <meta name="description" content="Laminance offers premium custom kitchen cabinets, shaker cabinets, and complete kitchen transformations starting at $25,000. Serving Franklin, NJ since October 2023." />
//         <meta name="keywords" content="kitchen cabinets Franklin NJ, custom cabinetry NJ, kitchen renovation $25K, shaker cabinets NJ, Laminance Franklin" />
//         <link rel="canonical" href="https://www.laminance.com/about" />
//         <meta name="viewport" content="width=device-width, initial-scale=1.0" />
//         <script type="application/ld+json">
//           {JSON.stringify({
//             "@context": "https://schema.org",
//             "@type": "HomeAndConstructionBusiness",
//             "name": "Laminance",
//             "description": "Premium kitchen cabinet craftsmanship and complete kitchen transformations",
//             "url": "https://www.laminance.com",
//             "telephone": businessInfo.phone,
//             "email": businessInfo.email,
//             "address": {
//               "@type": "PostalAddress",
//               "streetAddress": "418 Rt 23",
//               "addressLocality": "Franklin",
//               "addressRegion": "NJ",
//               "postalCode": "07416",
//               "addressCountry": "US"
//             },
//             "priceRange": "$$$",
//             "openingHours": "Mo-Fr 9:00-18:00, Sa 10:00-16:00",
//             "founder": "Laminance Team",
//             "foundingDate": "2023-10-01",
//             "makesOffer": {
//               "@type": "Offer",
//               "name": "Complete Kitchen Transformation",
//               "price": "25000",
//               "priceCurrency": "USD",
//               "description": "Starting price for complete kitchen renovation package"
//             }
//           })}
//         </script>
//       </head>

//       {/* Hero Section - Fully Responsive */}
//       <section className="relative bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-white py-12 md:py-20 lg:py-24">
//         <div className="absolute inset-0 bg-black/40 z-0"></div>
//         <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center">
//             <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-4 md:mb-6 tracking-tight">
//               Crafting <span className="font-bold bg-gradient-to-r from-orange-400 to-amber-400 bg-clip-text text-transparent">Timeless Kitchens</span>
//             </h1>
//             <p className="text-lg sm:text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-6 md:mb-8 font-light px-4">
//               Premium kitchen transformations in Franklin, NJ
//             </p>
//             <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center px-4">
//               <a 
//                 href="/contact" 
//                 className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-semibold rounded-full hover:shadow-xl hover:scale-105 transition-all duration-300 shadow-lg text-sm sm:text-base"
//               >
//                 Get Free Estimate
//               </a>
//               <a 
//                 href={`tel:${businessInfo.phone.replace(/\D/g, '')}`}
//                 className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-transparent border border-white/30 text-white font-semibold rounded-full hover:bg-white/10 transition-all text-sm sm:text-base"
//               >
//                 {businessInfo.phone}
//               </a>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Premium Package Showcase */}
//       <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-b from-white to-gray-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Package Header */}
//           <div className="text-center mb-10 md:mb-16 px-4">
//             <div className="inline-block px-4 sm:px-6 py-1.5 sm:py-2 bg-gradient-to-r from-amber-100 to-orange-100 rounded-full mb-3 sm:mb-4">
//               <span className="text-amber-800 font-semibold text-sm sm:text-base">Signature Offering</span>
//             </div>
//             <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
//               {transformationPackage.title}
//             </h2>
//             <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-4 sm:mb-6">
//               <span className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900">{transformationPackage.startingPrice}</span>
//               <span className="text-gray-600 text-base sm:text-lg">Starting Price</span>
//             </div>
//             <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto px-4">
//               {transformationPackage.description}
//             </p>
//           </div>

//           {/* Package Features Grid - Responsive */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 md:mb-16">
//             {transformationPackage.includes.map((item, index) => (
//               <div 
//                 key={index}
//                 className="group relative bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg sm:shadow-xl border border-gray-200 hover:shadow-2xl hover:border-orange-300 transition-all duration-300 cursor-pointer"
//                 onMouseEnter={() => !isMobile && setExpandedService(index)}
//                 onMouseLeave={() => !isMobile && setExpandedService(null)}
//                 onClick={() => isMobile && setExpandedService(expandedService === index ? null : index)}
//               >
//                 <div className="flex items-start space-x-3 sm:space-x-4">
//                   <div className="text-2xl sm:text-3xl">{item.icon}</div>
//                   <div className="flex-1 min-w-0">
//                     <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1 sm:mb-2">{item.title}</h3>
//                     <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
//                       {expandedService === index || isMobile ? item.details : `${item.details.substring(0, 50)}...`}
//                     </p>
//                   </div>
//                 </div>
//                 {(expandedService === index || isMobile) && (
//                   <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-orange-500 to-amber-500 rounded-b-xl sm:rounded-b-2xl"></div>
//                 )}
//               </div>
//             ))}
//           </div>

//           {/* Package CTA */}
//           <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 text-center relative overflow-hidden">
//             <div className="absolute top-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-gradient-to-br from-orange-500/20 to-transparent rounded-full -translate-y-16 sm:-translate-y-24 md:-translate-y-32 translate-x-8 sm:translate-x-16 md:translate-x-32"></div>
//             <div className="relative z-10">
//               <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-4 sm:mb-6">Ready for Your Dream Kitchen?</h3>
//               <p className="text-gray-300 text-sm sm:text-base md:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
//                 This premium package includes everything for a seamless, stress-free renovation starting at {transformationPackage.startingPrice}
//               </p>
//               <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
//                 <a 
//                   href="/contact" 
//                   className="w-full sm:w-auto px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-4 bg-white text-gray-900 font-bold rounded-full hover:bg-gray-100 hover:scale-105 transition-all shadow-lg sm:shadow-xl text-sm sm:text-base"
//                 >
//                   Book Free Consultation
//                 </a>
//                 <a 
//                   href="/gallery" 
//                   className="w-full sm:w-auto px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-4 bg-transparent border border-white text-white font-bold rounded-full hover:bg-white/10 transition-all text-sm sm:text-base"
//                 >
//                   View Our Work
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* The Laminance Difference - Updated Stats */}
//       <section className="py-12 md:py-16 lg:py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid lg:grid-cols-2 gap-10 md:gap-12 lg:gap-16 items-center">
//             <div className="relative">
//               <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 shadow-xl">
//                 <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
//                   The <span className="text-orange-600">Laminance</span> Difference
//                 </h2>
//                 <div className="space-y-3 sm:space-y-4">
//                   <p className="text-gray-700 text-base sm:text-lg">
//                     Since starting in {businessInfo.founded}, we've been transforming kitchens across {businessInfo.area} with our commitment to precision craftsmanship and innovative design.
//                   </p>
//                   <p className="text-gray-700 text-base sm:text-lg">
//                     Each cabinet is more than storage—it's a <strong>functional work of art</strong>, engineered for daily use while elevating your home's aesthetic.
//                   </p>
//                   <div className="mt-6 sm:mt-8">
//                     <blockquote className="border-l-3 sm:border-l-4 border-amber-500 pl-4 sm:pl-6 italic text-gray-600 text-base sm:text-lg md:text-xl">
//                       "We don't just install cabinets; we orchestrate spaces where life happens beautifully."
//                     </blockquote>
//                   </div>
//                 </div>
//               </div>
//             </div>
            
//             {/* Updated Stats Grid */}
//             <div className="grid grid-cols-2 gap-4 sm:gap-6">
//               {[
//                 { stat: "2000+", label: "Design Options", icon: "🎨" },
//                 { stat: "3D", label: "Free Design Visualization", icon: "🖥️" },
//                 { stat: "24hr", label: "Quote Response", icon: "⚡" },
//                 { stat: "100%", label: "Handcrafted", icon: "✋" }
//               ].map((item, index) => (
//                 <div key={index} className="bg-gradient-to-br from-gray-50 to-white p-4 sm:p-6 rounded-xl sm:rounded-2xl border border-gray-200 shadow-lg text-center group hover:shadow-xl transition-shadow">
//                   <div className="text-2xl sm:text-3xl md:text-4xl mb-2 sm:mb-4 opacity-80 group-hover:scale-110 transition-transform">{item.icon}</div>
//                   <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-1 sm:mb-2">{item.stat}</div>
//                   <div className="text-gray-600 font-medium text-xs sm:text-sm md:text-base leading-tight">{item.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Our Premium Cabinet Collection with Lamigloss */}
//       <section className="py-12 md:py-16 lg:py-20 bg-gradient-to-b from-gray-50 to-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-10 md:mb-16 px-4">
//             <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Our Premium Cabinet Collection</h2>
//             <p className="text-gray-600 text-base sm:text-lg md:text-xl max-w-3xl mx-auto">
//               From classic shaker to modern Lamigloss, we offer the finest cabinet solutions in {businessInfo.area}
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
//             {[
//               {
//                 title: "Shaker Cabinets",
//                 description: "Timeless classic with clean, simple lines",
//                 features: ["Raised panel design", "Versatile styling", "Multiple finishes", "Traditional appeal"],
//                 color: "from-amber-500/10 to-orange-500/10",
//                 popular: true,
//                 icon: "🏛️"
//               },
//               {
//                 title: " Acrylic Cabinets",
//                 description: "High-reflective luxury finish",
//                 features: ["Mirror-like surface", "Easy maintenance", "Modern aesthetic", "Premium durability"],
//                 color: "from-blue-500/10 to-indigo-500/10",
//                 premium: true,
//                 icon: "✨"
//               },
//               {
//                 title: "Lamigloss Cabinets",
//                 description: "Contemporary high-gloss finish",
//                 features: ["Sleek appearance", "Scratch-resistant", "Color variety", "UV protection"],
//                 color: "from-cyan-500/10 to-blue-500/10",
//                 icon: "🌈"
//               },
//               {
//                 title: "Super Matte Finish",
//                 description: "Luxury textured surface",
//                 features: ["Fingerprint resistant", "Sophisticated look", "Warm appearance", "Contemporary style"],
//                 color: "from-gray-500/10 to-gray-700/10",
//                 icon: "🎭"
//               }
//             ].map((cabinet, index) => (
//               <div key={index} className={`bg-gradient-to-br ${cabinet.color} p-6 sm:p-8 rounded-xl sm:rounded-2xl md:rounded-3xl border border-gray-200 shadow-lg sm:shadow-xl relative h-full flex flex-col`}>
//                 {cabinet.popular && (
//                   <div className="absolute -top-2 sm:-top-3 left-4 sm:left-6 px-3 sm:px-4 py-0.5 sm:py-1 bg-orange-500 text-white text-xs sm:text-sm font-bold rounded-full">
//                     Most Popular
//                   </div>
//                 )}
//                 {cabinet.premium && (
//                   <div className="absolute -top-2 sm:-top-3 left-4 sm:left-6 px-3 sm:px-4 py-0.5 sm:py-1 bg-indigo-600 text-white text-xs sm:text-sm font-bold rounded-full">
//                     Premium Choice
//                   </div>
//                 )}
                
//                 <div className="text-3xl sm:text-4xl mb-3 sm:mb-4">{cabinet.icon}</div>
//                 <h3 className="text-lg sm:text-xl md:text-[23px] font-bold text-gray-900 mb-2 sm:mb-3">{cabinet.title}</h3>
//                 <p className="text-gray-700 text-sm sm:text-base mb-4 sm:mb-6 flex-grow">{cabinet.description}</p>
                
//                 <ul className="space-y-2 sm:space-y-3 mb-6 sm:mb-8">
//                   {cabinet.features.map((feature, fIndex) => (
//                     <li key={fIndex} className="flex items-start">
//                       <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-amber-500 rounded-full mt-1.5 sm:mt-2 mr-2 sm:mr-3 flex-shrink-0"></div>
//                       <span className="text-gray-700 text-xs sm:text-sm md:text-base">{feature}</span>
//                     </li>
//                   ))}
//                 </ul>
                
                
//               </div>
//             ))}
//           </div>

//           {/* Lamigloss Information */}
          
//         </div>
//       </section>

//       {/* Get In Touch Section */}
//       <section className="py-12 md:py-16 lg:py-20">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 shadow-xl">
//             <div className="grid md:grid-cols-2 gap-8 md:gap-12">
//               <div>
//                 <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">Get In Touch</h2>
//                 <div className="space-y-4 sm:space-y-6">
//                   <div>
//                     <h3 className="text-xl sm:text-2xl font-bold text-orange-600 mb-1 sm:mb-2">Laminance</h3>
//                     <p className="text-gray-700 text-sm sm:text-base">{businessInfo.address}</p>
//                   </div>
                  
//                   <div>
//                     <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Contact Information</h4>
//                     <p className="text-gray-700 text-sm sm:text-base mb-1">
//                       <strong>Phone:</strong> {businessInfo.phone}
//                     </p>
//                     <p className="text-gray-700 text-sm sm:text-base">
//                       <strong>Email:</strong> {businessInfo.email}
//                     </p>
//                   </div>
                  
//                   <div>
//                     <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Service Area</h4>
//                     <p className="text-gray-700 text-sm sm:text-base">{businessInfo.area}</p>
//                   </div>
                  
//                   <div>
//                     <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">Business Hours</h4>
//                     <p className="text-gray-700 text-sm sm:text-base">
//                       Monday - Friday: 9:00 AM - 6:00 PM<br />
//                       Saturday: 10:00 AM - 4:00 PM<br />
//                       Sunday: By Appointment Only
//                     </p>
//                   </div>
//                 </div>
//               </div>
              
//               <div className="bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg w-full h-full">
//                 <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Ready to Start Your Project?</h3>
//                 <div className="space-y-3 sm:space-y-4">
//                   <a 
//                     href={`tel:${businessInfo.phone.replace(/\D/g, '')}`}
//                     className="flex items-center justify-center px-4 sm:px-6 py-3 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold rounded-lg sm:rounded-xl hover:shadow-lg hover:scale-[1.02] transition-all text-sm sm:text-base"
//                   >
//                     <span className="mr-2 sm:mr-3">📞</span>
//                     Call Now: {businessInfo.phone}
//                   </a>
                  
//                   <a 
//                     href={`mailto:${businessInfo.email}`}
//                     className="flex items-center justify-center px-4 sm:px-6 py-3 bg-white border border-orange-500 text-orange-600 font-bold rounded-lg sm:rounded-xl hover:bg-orange-50 transition-all text-sm sm:text-base"
//                   >
//                     <span className="mr-2 sm:mr-3">✉️</span>
//                     Email: {businessInfo.email}
//                   </a>
                  
//                   <a 
//                     href="/contact"
//                     className="flex items-center justify-center px-4 sm:px-6 py-3 bg-gray-900 text-white font-bold rounded-lg sm:rounded-xl hover:bg-gray-800 transition-all text-sm sm:text-base"
//                   >
//                     <span className="mr-2 sm:mr-3">📝</span>
//                     Online Contact Form
//                   </a>
//                 </div>
                
//                 <div className="mt-6 sm:mt-8 pt-6 sm:pt-8 border-t border-gray-200">
//                   <h4 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">Why Choose Laminance?</h4>
//                   <ul className="grid grid-cols-2 gap-2 sm:gap-3">
//                     {[
//                       "Free 3D Design",
//                       "Transparent Pricing",
//                       "Quality Guarantee",
//                       "Timely Completion",
//                       "Local Experts",
//                       "Free Consultation"
//                     ].map((item, idx) => (
//                       <li key={idx} className="flex items-center">
//                         <span className="text-green-500 mr-1.5 sm:mr-2 text-sm">✓</span>
//                         <span className="text-gray-700 text-xs sm:text-sm">{item}</span>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default AboutPage;



// src/pages/AboutPage.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Add this import
import "../Component/Home/theme.css"; // Import the CSS file
import { MessageSquare } from 'lucide-react';

const AboutPage = () => {
  const navigate = useNavigate(); // Add this hook
  const [expandedService, setExpandedService] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size for responsive adjustments
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Add font styles to document head
  useEffect(() => {
    // Add Bell MT and Inter fonts
    const style = document.createElement('style');
    style.textContent = `
      @import url('https://fonts.cdnfonts.com/css/bell-mt');
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
      
      .bell-mt-primary {
        font-family: 'Bell MT', serif !important;
      }
      
      .inter-secondary {
        font-family: 'Inter', sans-serif !important;
      }
      
      body {
        font-family: 'Inter', sans-serif;
      }
      
      h1, h2, h3, h4, h5, h6 {
        font-family: 'Bell MT', serif;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  // Updated Business Information
  const businessInfo = {
    name: "Laminance",
    founded: "2024",
    address: "418 Rt 23, Franklin, NJ, 07416",
    phone: "(862) 450-6069",
    email: "Contactus@laminance.com",
    area: "Entire New Jersey"
  };

  // Updated transformation package with starting price
  const transformationPackage = {
    startingPrice: "$25,000",
    title: "Complete Kitchen Transformation",
    description: "Everything you need for a complete kitchen renovation, handled by our expert team from start to finish.",
    includes: [
      {
        title: "Premium Cabinets",
        icon: "🗄️",
        details: "Custom-built cabinets with your choice of acrylic, matte, gloss, or shaker styles"
      },
      {
        title: "Luxury Countertops",
        icon: "🪨",
        details: "Quartz, granite, or marble countertop installation with professional sealing"
      },
      {
        title: "Designer Backsplash",
        icon: "🧱",
        details: "Professional backsplash design with premium tile selection and installation"
      },
      {
        title: "Professional Painting",
        icon: "🎨",
        details: "Complete kitchen painting with premium, low-VOC paints and protective coatings"
      },
      {
        title: "High-End Sink & Plumbing",
        icon: "🚰",
        details: "Undermount or farmhouse sink with professional plumbing and garbage disposal"
      },
      {
        title: "Premium Hardware",
        icon: "🔩",
        details: "Hand-selected knobs, pulls, soft-close hinges, and all finishing hardware"
      },
      {
        title: "Electrical Updates",
        icon: "💡",
        details: "Lighting fixtures, outlets, under-cabinet lighting, and any necessary electrical work"
      },
      {
        title: "Complete Installation",
        icon: "👷",
        details: "Full labor from demolition to final inspection and cleanup"
      }
    ]
  };

  // Navigation handler function
  const handleNavigation = (path) => {
    navigate(path);
    // Scroll to top on navigation
    window.scrollTo(0, 0);
  };

  return (
    <div 
      className="min-h-screen inter-secondary"
      style={{
        background: "var(--gradient-bg)",
      }}
    >
      {/* SEO Meta Tags */}
      <head>
        <title>About Laminance | Premium Kitchen Cabinets & Complete Kitchen Transformation in Franklin, NJ</title>
        <meta name="description" content="Laminance offers premium custom kitchen cabinets, shaker cabinets, and complete kitchen transformations starting at $25,000. Serving Franklin, NJ since October 2023." />
        <meta name="keywords" content="kitchen cabinets Franklin NJ, custom cabinetry NJ, kitchen renovation $25K, shaker cabinets NJ, Laminance Franklin" />
        <link rel="canonical" href="https://www.laminance.com/about" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "HomeAndConstructionBusiness",
            "name": "Laminance",
            "description": "Premium kitchen cabinet craftsmanship and complete kitchen transformations",
            "url": "https://www.laminance.com",
            "telephone": businessInfo.phone,
            "email": businessInfo.email,
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "418 Rt 23",
              "addressLocality": "Franklin",
              "addressRegion": "NJ",
              "postalCode": "07416",
              "addressCountry": "US"
            },
            "priceRange": "$$$",
            "openingHours": "Mo-Fr 9:00-18:00, Sa 10:00-16:00",
            "founder": "Laminance Team",
            "foundingDate": "2023-10-01",
            "makesOffer": {
              "@type": "Offer",
              "name": "Complete Kitchen Transformation",
              "price": "25000",
              "priceCurrency": "USD",
              "description": "Starting price for complete kitchen renovation package"
            }
          })}
        </script>
      </head>

      {/* Hero Section - Fully Responsive */}
      {/* Note: Hero section was empty in original code */}

      {/* Premium Package Showcase */}
      <section className="py-4 md:py-6 lg:py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Package Header */}
          <div className="text-center mb-10 md:mb-16 px-4">
  
            <h1
              className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4 px-4"
              style={{
                color: "var(--color-primary-500)",
              }}
            >
              {transformationPackage.title}
            </h1>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-4 sm:mb-6">
              <span 
                className="bell-mt-primary text-3xl sm:text-4xl md:text-5xl font-bold"
                style={{
                  color: "var(--color-primary-500)",
                }}
              >
                {transformationPackage.startingPrice}
              </span>
              <span 
                className="bell-mt-primary inter-secondary text-base sm:text-lg"
                style={{
                  color: "var(--color-gray-600)",
                }}
              >
                Starting Price
              </span>
            </div>
            
            <p 
              className="inter-secondary text-base sm:text-lg md:text-xl max-w-3xl mx-auto px-4"
              style={{
                color: "var(--color-gray-600)",
              }}
            >
              {transformationPackage.description}
            </p>

            {/* Decorative Line */}
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{
                  background: "var(--gradient-primary)",
                }}
              ></div>
            </div>
          </div>

          {/* Package Features Grid - Responsive */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12 md:mb-16">
            {transformationPackage.includes.map((item, index) => (
              <div 
                key={index}
                className="group relative rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
                style={{
                  backgroundColor: "var(--color-white)",
                  boxShadow: "var(--shadow-medium)",
                }}
                onMouseEnter={() => !isMobile && setExpandedService(index)}
                onMouseLeave={() => !isMobile && setExpandedService(null)}
                onClick={() => isMobile && setExpandedService(expandedService === index ? null : index)}
              >
                <div className="flex items-start space-x-3 sm:space-x-4">
                  <div className="text-2xl sm:text-3xl">{item.icon}</div>
                  <div className="flex-1 min-w-0">
                    <h3 
                      className="bell-mt-primary text-base sm:text-lg font-bold mb-1 sm:mb-2"
                      style={{
                        color: "var(--color-primary-600)",
                      }}
                    >
                      {item.title}
                    </h3>
                    <p 
                      className="inter-secondary text-xs sm:text-sm leading-relaxed"
                      style={{
                        color: "var(--color-gray-600)",
                      }}
                    >
                      {expandedService === index || isMobile ? item.details : `${item.details.substring(0, 50)}...`}
                    </p>
                  </div>
                </div>
                
                {/* Subtle overlay on hover */}
                <div 
                  className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-all duration-300 rounded-xl sm:rounded-2xl"
                  style={{
                    backgroundColor: "transparent",
                  }}
                ></div>
                
                {(expandedService === index || isMobile) && (
                  <div 
                    className="absolute bottom-0 left-0 right-0 h-1 rounded-b-xl sm:rounded-b-2xl"
                    style={{
                      background: "var(--gradient-primary)",
                    }}
                  ></div>
                )}
              </div>
            ))}
          </div>

          {/* Package CTA */}
          <div 
            className="rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 text-center relative overflow-hidden"
            style={{
              background: "var(--gradient-primary)",
              boxShadow: "var(--shadow-large)",
            }}
          >
            {/* Background Decorative Elements */}
            <div 
              className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full -translate-x-1/2 -translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{
                backgroundColor: "var(--color-white)",
              }}
            ></div>
            <div 
              className="absolute bottom-0 right-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 rounded-full translate-x-1/2 translate-y-1/2 opacity-20 blur-3xl" 
              aria-hidden="true"
              style={{
                backgroundColor: "var(--color-white)",
              }}
            ></div>

            <div className="relative z-10">
              <h3 
                className="bell-mt-primary text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6"
                style={{
                  color: "var(--color-white)",
                }}
              >
                Ready for Your Dream Kitchen?
              </h3>
              <p 
                className="inter-secondary text-sm sm:text-base md:text-lg mb-6 sm:mb-8 max-w-2xl mx-auto px-4"
                style={{
                  color: "rgba(255, 255, 255, 0.9)",
                }}
              >
                This premium package includes everything for a seamless, stress-free renovation starting at {transformationPackage.startingPrice}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
                <button
                  onClick={() => handleNavigation('/contact#contact-form')}
                  className="inter-secondary w-full sm:w-auto px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-4 font-bold rounded-xl hover:bg-gray-100 transition-all duration-300 shadow-lg sm:shadow-xl text-sm sm:text-base cursor-pointer"
                  style={{
                    backgroundColor: "var(--color-white)",
                    color: "var(--color-primary-600)",
                  }}
                >
                  Book Free Consultation
                </button>
                <button
  onClick={() => {
    // Navigate to home page with state
    navigate('/', { 
      state: { scrollToCollections: true } 
    });
    window.scrollTo(0, 0);
  }}
  className="inter-secondary w-full sm:w-auto px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-4 font-bold rounded-xl transition-all duration-300 text-sm sm:text-base cursor-pointer"
  style={{
    border: "2px solid var(--color-white)",
    color: "var(--color-white)",
    backgroundColor: "transparent",
  }}
>
  View Our Work
</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Laminance Difference */}
      <section className="py-12 md:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Centered Heading */}
          <div className="text-center mb-12">
            <h2 
              className="bell-mt-primary text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-bold mb-4"
              style={{
                color: "var(--color-primary-500)",
              }}
            >
              Why Choose Laminance ?
            </h2>
            {/* Decorative line under heading */}
          </div>

          <div className="grid lg:grid-cols-2 gap-10 md:gap-12 lg:gap-16 items-center">
            <div className="relative">
              {/* Background Decorative Elements */}
              <div 
                className="absolute -top-10 -left-10 w-32 h-32 rounded-full opacity-30 blur-3xl animate-pulse" 
                aria-hidden="true"
                style={{
                  backgroundColor: "var(--color-primary-100)",
                  animation: "pulse 3s ease-in-out infinite",
                }}
              ></div>

              <div 
                className="relative z-10 rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 shadow-xl group hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
                style={{
                  background: "var(--color-primary-500)",
                }}
              >
                {/* Animated border effect */}
                <div 
                  className="absolute inset-0 rounded-xl sm:rounded-2xl md:rounded-3xl opacity-0 group-hover:opacity-20 transition-opacity duration-500"
                  style={{
                    background: "radial-gradient(circle at 30% 50%, var(--color-white) 0%, transparent 70%)",
                  }}
                ></div>

                <div 
                  className="inter-secondary inline-flex items-center gap-2 px-4 py-2 rounded-full mb-4 relative overflow-hidden"
                  style={{
                    backgroundColor: "var(--color-primary-100)",
                    color: "var(--color-primary-700)",
                  }}
                >
                  <div 
                    className="w-2 h-2 rounded-full animate-ping absolute" 
                    aria-hidden="true"
                    style={{
                      backgroundColor: "var(--color-primary-500)",
                    }}
                  ></div>
                  <div 
                    className="w-2 h-2 rounded-full animate-pulse relative" 
                    aria-hidden="true"
                    style={{
                      backgroundColor: "var(--color-primary-500)",
                    }}
                  ></div>
                  <span className="text-sm font-semibold relative z-10">Why Us</span>
                </div>

                <h2 
                  className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6"
                  style={{
                    color: "var(--color-gray-900)",
                  }}
                >
                  The <span style={{ color: "var(--color-white)" }}>Laminance</span> Difference
                </h2>

                <div className="space-y-3 sm:space-y-4">
                  <p 
                    className="inter-secondary text-base sm:text-lg transform transition-all duration-300 hover:translate-x-2"
                    style={{
                      color: "var(--color-white)",
                    }}
                  >
                    Since starting in {businessInfo.founded}, we've been transforming kitchens across {businessInfo.area} with our commitment to precision craftsmanship and innovative design.
                  </p>
                  <p 
                    className="inter-secondary text-base sm:text-lg transform transition-all duration-300 hover:translate-x-2 hover:delay-75"
                    style={{
                      color: "var(--color-white)",
                    }}
                  >
                    Each cabinet is more than storage—it's a <strong className="relative group/strong">
                      functional work of art
                      <span 
                        className="absolute -bottom-1 left-0 w-0 h-0.5 group-hover/strong:w-full transition-all duration-300"
                        style={{ backgroundColor: "var(--color-primary-300)" }}
                      ></span>
                    </strong>, engineered for daily use while elevating your home's aesthetic.
                  </p>
                  <div className="mt-6 sm:mt-8">
                    <blockquote 
                      className="inter-secondary border-l-3 sm:border-l-4 pl-4 sm:pl-6 italic text-base sm:text-lg md:text-xl relative group/quote hover:pl-8 transition-all duration-300"
                      style={{
                        borderLeftColor: "var(--color-primary-500)",
                        color: "var(--color-white)",
                      }}
                    >
                      <span className="absolute -left-2 opacity-0 group-hover/quote:opacity-100 transition-opacity duration-300 text-2xl" style={{ color: "var(--color-primary-300)" }}>"</span>
                      We don't just install cabinets; we orchestrate spaces where life happens beautifully.
                      <span className="absolute -right-2 bottom-0 opacity-0 group-hover/quote:opacity-100 transition-opacity duration-300 text-2xl" style={{ color: "var(--color-primary-300)" }}>"</span>
                    </blockquote>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Stats Grid with Enhanced Effects */}
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              {[
                { stat: "2000+", label: "Color Options", icon: "🎨", delay: 0 },
                { stat: "3D", label: "Free Design", icon: "🖥️", delay: 100 },
                { stat: "24hr", label: "Quote Response", icon: "⚡", delay: 200 },
                { stat: "100%", label: "Handcrafted", icon: "✋", delay: 300 }
              ].map((item, index) => (
                <div 
                  key={index} 
                  className="inter-secondary p-4 sm:p-6 rounded-xl sm:rounded-2xl border text-center group hover:shadow-2xl transition-all duration-300 relative overflow-hidden"
                  style={{
                    backgroundColor: "var(--color-white)",
                    borderColor: "var(--border-light)",
                    boxShadow: "var(--shadow-medium)",
                    animation: `fadeInUp 0.6s ease-out ${item.delay}ms both`,
                  }}
                >
                  {/* Animated background effect */}
                  <div 
                    className="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-500 transform scale-0 group-hover:scale-100"
                    style={{
                      background: "radial-gradient(circle at center, var(--color-primary-500) 0%, transparent 70%)",
                    }}
                  ></div>

                  {/* Icon with enhanced hover effect */}
                  <div 
                    className="text-2xl sm:text-3xl md:text-4xl mb-2 sm:mb-4 opacity-80 group-hover:scale-125 group-hover:rotate-12 transition-all duration-300 relative z-10"
                    style={{
                      color: "var(--color-primary-500)",
                    }}
                  >
                    {item.icon}
                  </div>

                  {/* Stat with underline effect */}
                  <div className="relative inline-block">
                    <div 
                      className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl font-bold mb-1 sm:mb-2 relative z-10"
                      style={{
                        color: "var(--color-primary-500)",
                      }}
                    >
                      {item.stat}
                    </div>
                    <div 
                      className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 group-hover:w-full h-0.5 transition-all duration-300"
                      style={{ backgroundColor: "var(--color-primary-500)" }}
                    ></div>
                  </div>

                  {/* Label with subtle hover effect */}
                  <div 
                    className="inter-secondary font-medium text-xs sm:text-sm md:text-base leading-tight relative z-10 group-hover:scale-105 transition-transform duration-300"
                    style={{
                      color: "var(--color-gray-600)",
                    }}
                  >
                    {item.label}
                  </div>

                  {/* Corner accents */}
                  <div 
                    className="absolute top-2 left-2 w-2 h-2 border-t-2 border-l-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ borderColor: "var(--color-primary-500)" }}
                  ></div>
                  <div 
                    className="absolute top-2 right-2 w-2 h-2 border-t-2 border-r-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ borderColor: "var(--color-primary-500)" }}
                  ></div>
                  <div 
                    className="absolute bottom-2 left-2 w-2 h-2 border-b-2 border-l-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ borderColor: "var(--color-primary-500)" }}
                  ></div>
                  <div 
                    className="absolute bottom-2 right-2 w-2 h-2 border-b-2 border-r-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                    style={{ borderColor: "var(--color-primary-500)" }}
                  ></div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Add animation keyframes to the component */}
        <style jsx>{`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          @keyframes pulse {
            0%, 100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 0.5;
              transform: scale(1.1);
            }
          }
          
          @keyframes float {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-10px);
            }
          }
        `}</style>
      </section>

      {/* Our Premium Cabinet Collection */}
      <section className="py-12 md:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-10 md:mb-16 px-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6"
              style={{
                background: "var(--bg-primary-10)",
                border: "1px solid var(--border-primary-20)",
              }}
            >
              <MessageSquare size={14} style={{ color: "var(--color-primary-400)" }} />
              <span className="text-sm font-medium" style={{ color: "var(--color-primary-400)" }}>
                Our Cabinets
              </span>
            </div>
            <h2 
              className="bell-mt-primary text-3xl sm:text-x4l md:text-5xl font-bold mb-3 sm:mb-4"
              style={{
                color: "var(--color-primary-500)",
              }}
            >
              Premium Cabinet Collection
            </h2>
            
            <p 
              className="inter-secondary text-base sm:text-lg md:text-xl max-w-3xl mx-auto"
              style={{
                color: "var(--color-gray-600)",
              }}
            >
              From classic shaker to modern Lamigloss, we offer the finest cabinet solutions in {businessInfo.area}
            </p>

            {/* Decorative Line */}
            <div className="flex justify-center mt-6" aria-hidden="true">
              <div 
                className="w-24 h-1 rounded-full"
                style={{
                  background: "var(--gradient-primary)",
                }}
              ></div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {[
              {
                title: "Shaker Cabinets",
                description: "Timeless classic with clean, simple lines",
                features: ["Raised panel design", "Versatile styling", "Multiple finishes"],
                popular: true,
                icon: "https://res.cloudinary.com/dbelveonz/image/upload/v1771092923/gate3_ivhqeg.png"
              },
              {
                title: "Acrylic Cabinets",
                description: "High-reflective luxury finish",
                features: ["Mirror-like surface", "Easy maintenance", "Modern aesthetic"],
                premium: true,
                icon: "https://res.cloudinary.com/dbelveonz/image/upload/v1771092921/gate17_zaziny.webp"
              },
              {
                title: "Super Matte Cabinets",
                description: "Luxury textured surface",
                features: ["Fingerprint resistant", "Sophisticated look", "Warm appearance"],
                icon: "https://res.cloudinary.com/dbelveonz/image/upload/v1771092921/gateM2_yfcke7.jpg ",
              },
              {
                title: "Lamigloss Cabinets",
                description: "Contemporary high-gloss finish",
                features: ["Sleek appearance", "Scratch-resistant", "Color variety"],
                icon: "https://res.cloudinary.com/dbelveonz/image/upload/v1771092921/gg2_eb8dpn.jpg"
              }
            ].map((cabinet, index) => (
              <div 
                key={index} 
                className="group relative p-6 sm:p-8 rounded-xl sm:rounded-2xl md:rounded-3xl border shadow-lg hover:shadow-2xl transition-all duration-300 h-full flex flex-col"
                style={{
                  backgroundColor: "var(--color-white)",
                  borderColor: "var(--border-light)",
                  boxShadow: "var(--shadow-medium)",
                }}
              >
                {cabinet.popular && (
                  <div 
                    className="inter-secondary absolute -top-2 sm:-top-3 left-4 sm:left-6 px-3 sm:px-4 py-0.5 sm:py-1 text-white text-xs sm:text-sm font-bold rounded-full"
                    style={{
                      background: "var(--gradient-primary)",
                    }}
                  >
                    Most Popular
                  </div>
                )}
                {cabinet.premium && (
                  <div 
                    className="inter-secondary absolute -top-2 sm:-top-3 left-4 sm:left-6 px-3 sm:px-4 py-0.5 sm:py-1 text-white text-xs sm:text-sm font-bold rounded-full"
                    style={{
                      background: "linear-gradient(135deg, var(--color-primary-500), var(--color-secondary-500))",
                    }}
                  >
                    Premium Choice
                  </div>
                )}
                
                {/* Icon Container - Updated with img tag */}
                <div 
                  className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl overflow-hidden mb-3 sm:mb-4 group-hover:scale-110 transition-transform"
                  style={{
                    backgroundColor: "var(--color-primary-50)",
                  }}
                >
                  <img
                    src={cabinet.icon}
                    alt={cabinet.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/assets/Images/fallback-cabinet.jpg'; // Optional fallback
                    }}
                  />
                </div>

                <h3 
                  className="bell-mt-primary text-lg sm:text-xl md:text-[23px] font-bold mb-2 sm:mb-3"
                  style={{
                    color: "var(--color-primary-500)",
                  }}
                >
                  {cabinet.title}
                </h3>
                <p 
                  className="inter-secondary text-sm sm:text-base mb-4 sm:mb-6 flex-grow"
                  style={{
                    color: "var(--color-gray-600)",
                  }}
                >
                  {cabinet.description}
                </p>
                
                <ul className="space-y-2 sm:space-y-3">
                  {cabinet.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start">
                      <div 
                        className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full mt-1.5 sm:mt-2 mr-2 sm:mr-3 flex-shrink-0"
                        style={{
                          backgroundColor: "var(--color-primary-500)",
                        }}
                      ></div>
                      <span 
                        className="inter-secondary text-xs sm:text-sm md:text-base"
                        style={{
                          color: "var(--color-gray-600)",
                        }}
                      >
                        {feature}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <section className="py-12 md:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div 
            className="rounded-xl sm:rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-12 shadow-xl"
            style={{
              background: "var(--color-primary-500)",
            }}
          >
            {/* Section Header */}

            <div className="grid md:grid-cols-2 gap-8 md:gap-12">
              <div>
                <h2 
                  className="bell-mt-primary text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6"
                  style={{
                    color: "var(--color-gray-900)",
                  }}
                >
                  Get In Touch
                </h2>
                <div className="space-y-4 sm:space-y-6">
                  <div>
                    <h3 
                      className="bell-mt-primary text-xl sm:text-2xl font-bold mb-1 sm:mb-2"
                      style={{
                        color: "var(--color-white)",
                      }}
                    >
                      Laminance
                    </h3>
                    <p 
                      className="inter-secondary text-sm sm:text-base"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      {businessInfo.address}
                    </p>
                  </div>
                  
                  <div>
                    <h4 
                      className="bell-mt-primary text-base sm:text-lg font-semibold mb-1 sm:mb-2"
                      style={{
                        color: "var(--color-gray-900)",
                      }}
                    >
                      Contact Information
                    </h4>
                    <p 
                      className="inter-secondary text-sm sm:text-base mb-1"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      <strong>Phone:</strong> {businessInfo.phone}
                    </p>
                    <p 
                      className="inter-secondary text-sm sm:text-base"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      <strong>Email:</strong> {businessInfo.email}
                    </p>
                  </div>
                  
                  <div>
                    <h4 
                      className="bell-mt-primary text-base sm:text-lg font-semibold mb-1 sm:mb-2"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      Service Area
                    </h4>
                    <p 
                      className="inter-secondary text-sm sm:text-base"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      {businessInfo.area}
                    </p>
                  </div>
                  
                  <div>
                    <h4 
                      className="bell-mt-primary text-base sm:text-lg font-semibold mb-1 sm:mb-2"
                      style={{
                        color: "var(--color-gray-900)",
                      }}
                    >
                      Business Hours
                    </h4>
                    <p 
                      className="inter-secondary text-sm sm:text-base"
                      style={{
                        color: "#ece6e6",
                      }}
                    >
                      Monday - Friday: 9:00 AM - 6:00 PM<br />
                      Saturday: 10:00 AM - 4:00 PM<br />
                      Sunday: By Appointment Only
                    </p>
                  </div>
                </div>
              </div>
              
              <div 
                className="rounded-xl sm:rounded-2xl p-6 sm:p-8 shadow-lg w-full h-full"
                style={{
                  backgroundColor: "var(--color-white)",
                }}
              >
                <h3 
                  className="bell-mt-primary text-xl sm:text-2xl font-bold mb-4 sm:mb-6"
                  style={{
                    color: "var(--color-primary-500)",
                  }}
                >
                  Ready to Start Your Project?
                </h3>
                <div className="space-y-3 sm:space-y-4">
                  <a 
                    href={`tel:${businessInfo.phone.replace(/\D/g, '')}`}
                    className="inter-secondary flex items-center justify-center px-4 sm:px-6 py-3 font-bold rounded-lg sm:rounded-xl hover:scale-[1.02] transition-all text-sm sm:text-base"
                    style={{
                      background: "var(--gradient-primary)",
                      color: "var(--color-white)",
                    }}
                  >
                    <span className="mr-2 sm:mr-3">📞</span>
                    Call Now: {businessInfo.phone}
                  </a>
                  
                  <a 
                    href={`mailto:${businessInfo.email}`}
                    className="inter-secondary flex items-center justify-center px-4 sm:px-6 py-3 font-bold rounded-lg sm:rounded-xl transition-all text-sm sm:text-base"
                    style={{
                      backgroundColor: "var(--color-white)",
                      border: "2px solid var(--color-primary-500)",
                      color: "var(--color-primary-600)",
                    }}
                  >
                    <span className="mr-2 sm:mr-3">✉️</span>
                    Email Us
                  </a>
                  
                  <button
                    onClick={() => handleNavigation('/contact#contact-form')}
                    className="inter-secondary w-full flex items-center justify-center px-4 sm:px-6 py-3 font-bold rounded-lg sm:rounded-xl transition-all text-sm sm:text-base cursor-pointer"
                    style={{
                      backgroundColor: "var(--color-gray-900)",
                      border: "2px solid var(--color-primary-500)",
                      color: "var(--color-primary-500)",
                    }}
                  >
                    <span className="mr-2 sm:mr-3">📝</span>
                    Contact Form
                  </button>
                </div>
                
                <div className="mt-6 sm:mt-8 pt-6 sm:pt-8" style={{ borderTop: "1px solid var(--border-light)" }}>
                  <h4 
                    className="bell-mt-primary text-base sm:text-lg font-semibold mb-3 sm:mb-4"
                    style={{
                      color: "var(--color-primary-500)",
                    }}
                  >
                    Why Choose Laminance?
                  </h4>
                  <ul className="grid grid-cols-2 gap-2 sm:gap-3">
                    {[
                      "Free 3D Design",
                      "Transparent Pricing",
                      "Quality Guarantee",
                      "Timely Completion",
                      "Local Experts",
                      "Free Consultation"
                    ].map((item, idx) => (
                      <li key={idx} className="flex items-center">
                        <span 
                          className="mr-1.5 sm:mr-2 text-sm"
                          style={{
                            color: "var(--color-primary-500)",
                          }}
                        >
                          ✓
                        </span>
                        <span 
                          className="inter-secondary text-xs sm:text-sm"
                          style={{
                            color: "var(--color-gray-600)",
                          }}
                        >
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Decorative Line at bottom */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;